import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { APIContracts, APIControllers } from 'authorizenet';

import { GlobalService } from '../services/global.service';
import Utils from '../shared/utility';

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.css']
})

export class SignUpComponent implements OnInit {

    public currentAddEditClientScreen: any = 0;
    public previousAddEditClientScreen: any = 0;
    public billingPeriod: Number = 1; // 0 Monthly 1 Annual
    public selectedPackage: string = 'full';
    public allStates: any[] = Utils.allStates;

    hidePass: boolean = true;
    
    public validFormInputs: any;
    mediumRegex = new RegExp("^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$");
    usernameRegex = new RegExp(/^[a-zA-Z0-9-_]+$/);
    stringRegex = new RegExp(/^[a-zA-Z ]{2,30}$/);
    addressRegex = new RegExp(/[A-Za-z0-9'\.\-\s\,]/);
    zipRegex = new RegExp(/^\d{5}(?:[-\s]\d{4})?$/);
    emailRegex = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$");
    phoneRegex = new RegExp(/^(\d{10}|\d{12})$/);
    cardNumberRegex = new RegExp(/^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/)


    public signUpForm: any;
    public cardError: string;
    public backendError: string = '';

    showCreateAccountBtn: boolean = false;

    public isS: boolean;

    private billingSubtitle = 'Build stronger client relationships with our complete guide to creating personalized reports. Each report features actuarial data projections and income solutions for clients and their spouses. This package includes Healthcare Cost Projection, Long-Term Care Cost Projection, Medicare Means Testing Optimization, and Social Security Optimization.';

    generalForm: FormGroup;
    agentForm: FormGroup;
    paymentForm: FormGroup;


    constructor(private globalService: GlobalService, private router: Router, private formBuilder: FormBuilder, private currencyPipe: CurrencyPipe) { }

    ngOnInit() {
        //remove NA from list
        this.allStates.shift();

        this.generalForm = this.formBuilder.group({
            firstName: ['', [Validators.required, Validators.pattern(this.stringRegex)]],
            lastName: ['', [Validators.required, Validators.pattern(this.stringRegex)]],
            jobTitle: [''],
            address1: ['', [Validators.required, Validators.pattern(this.addressRegex)]],
            address2: [''],
            city: ['', Validators.required],
            state: ['', [Validators.required, Validators.pattern(this.stringRegex)]],
            zip: ['', [Validators.required, Validators.pattern(this.zipRegex)]],
            userName: ['', [Validators.required, Validators.pattern(this.usernameRegex)]],
            email: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
            phone: ['', [Validators.required]],
            password: ['', [Validators.required, Validators.pattern(this.mediumRegex), Validators.minLength(8)]],
            confirmPassword: ['', [Validators.required]]
        })

        this.agentForm = this.formBuilder.group({
            isAgree: [false, [Validators.requiredTrue]]
        })

        this.paymentForm = this.formBuilder.group({
            cardNumber: ['', [Validators.required, Validators.pattern(this.cardNumberRegex)]],
            expirationDate: ['', [Validators.required]],
            ccv: ['', [Validators.required]],
            firstName: ['', [Validators.required, Validators.pattern(this.stringRegex)]],
            lastName: ['', [Validators.required, Validators.pattern(this.stringRegex)]],
            address1: ['', [Validators.required, Validators.pattern(this.addressRegex)]],
            address2: [''],
            city: ['', Validators.required],
            state: ['', [Validators.required, Validators.pattern(this.stringRegex)]],
            zip: ['', [Validators.required, Validators.pattern(this.zipRegex)]],
            //password: ['', [Validators.required, Validators.pattern(this.mediumRegex), Validators.minLength(8)]],
            //confirmPassword: ['', [Validators.required]]
        })
        this.isS = (Number(localStorage.getItem('orgID')) === 371 || Number(localStorage.getItem('parentID')) === 371) ? true : false;

        this.signUpForm = {
            personalInformation: {
                invitationCode: '',
                firstName: '',
                lastName: '',
                jobTitle: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
                email: '',
                phone: '',
                username: '',
                password: '',
                passwordConfirm: '',
            },
            agentAgreement: {
                agrees: false,
            },
            softwareSubscription: {
                frequency: '',
                package: ''
            }, paymentMethod: {
                cardNumber: '',
                expDate: '',
                cvv: '',
                firstName: '',
                lastName: '',
                company: '',
                address1: '',
                address2: '',
                state: '',
                zip: '',
            }
        }

        this.cardError = ""

        this.signUpForm.softwareSubscription.frequency = this.billingPeriod === 0 ? 'monthly' : 'annual';
        this.signUpForm.softwareSubscription.package = this.selectedPackage;

        this.validFormInputs = [
            { isValid: false },
            { isValid: false },
            { isValid: false },
            { isValid: false },
        ];

        this.updateAddEditClientScreen(0);
    }

    sendPaymentDataToAnet() {
        // Sandbox
        // var authData = {
        //     clientKey: '9mL4QnXjf5YXQ626yHs56FkX4CMfSY6W75JvJGje4s7x7Frt8cDJ3Er5qXt3WJwc',
        //     apiLoginID: '4EV5PKurc9Bk',
        // };

        // Production
        var authData = {
            clientKey: '8PhwLM8spU37XF47BYsuZ3wXSyEWZ4cc7n377g6jJ6Nt4KY6Gh4TA6ZyA5sxjNXt',
            apiLoginID: '6Rfb46R3',
        };

        var cardData = {
            cardNumber: this.signUpForm.paymentMethod.cardNumber,
            month: this.signUpForm.paymentMethod.expDate.split('/')[0],
            year: '20' + this.signUpForm.paymentMethod.expDate.split('/')[1],
            cardCode: this.signUpForm.paymentMethod.cvv
        };

        var secureData = {
            authData,
            cardData,
        };

        window['Accept'].dispatchData(secureData, this.responseHandler.bind(this));
    }

    public error: any;
    public successMessage: any;
    public sendingPaymentDetails: boolean = false;
    public accountCreated: boolean = false;
    public accountFailed: boolean = false;

    responseHandler() {
        if (arguments[0] && arguments[0].messages && arguments[0].messages.resultCode == "Error") {
            this.cardError = "";

            for (var index in arguments[0].messages.message) {
                this.cardError += arguments[0].messages.message[index]['text'] + "\n";
            }

        } else {

            var ClientData = {
                DataValue: arguments[0].opaqueData.dataValue,
                DataDescriptor: arguments[0].opaqueData.dataDescriptor,
                // DataValue: '',
                // DataDescriptor: '',
                ProductCode: this.signUpForm.softwareSubscription.package,
                ProductDuration: this.signUpForm.softwareSubscription.frequency,
                FirstName: this.signUpForm.paymentMethod.firstName,
                LastName: this.signUpForm.paymentMethod.lastName,
                State: this.signUpForm.paymentMethod.state,
                Zip: this.signUpForm.paymentMethod.zip,
                Phone: this.signUpForm.personalInformation.phone || '',

                Email: this.signUpForm.personalInformation.email || '',
                Address: this.signUpForm.paymentMethod.address1,
                Company: this.signUpForm.paymentMethod.company,
                CustomerFirstName: this.signUpForm.personalInformation.firstName,
                CustomerLastName: this.signUpForm.personalInformation.lastName,
                CustomerEmail: this.signUpForm.personalInformation.email || '',
                CustomerPhone: this.signUpForm.personalInformation.phone || '',
                CustomerAddress: this.signUpForm.personalInformation.address1,
                CustomerZip: this.signUpForm.personalInformation.zip,
                CustomerState: this.signUpForm.personalInformation.state
            }

            var UserModel = {
                InvitationalCode: this.signUpForm.personalInformation.invitationCode,
                FirstName: this.signUpForm.personalInformation.firstName,
                LastName: this.signUpForm.personalInformation.lastName,
                JobTitle: this.signUpForm.personalInformation.jobTitle,
                Address1: this.signUpForm.personalInformation.address1,
                Address2: this.signUpForm.personalInformation.address2,
                State: this.signUpForm.personalInformation.state,
                Zip: this.signUpForm.personalInformation.zip,
                Email: this.signUpForm.personalInformation.email,
                Phone: this.signUpForm.personalInformation.phone,
                Username: this.signUpForm.personalInformation.username,
                AgentAgrees: this.signUpForm.agentAgreement.agrees,
                Duration: this.signUpForm.softwareSubscription.frequency,
                Package: this.signUpForm.softwareSubscription.package,
                Price: '',
            }

            // console.log(ClientData);

            var PW = this.signUpForm.personalInformation.password;

            this.sendingPaymentDetails = true;

            this.globalService.CompletePayment({ ClientData, UserModel, PW })
                .subscribe(
                    response => {
                        this.completedRegistration = true;
                        this.sendingPaymentDetails = false;

                        if (response.Status == 1 || response.Status == 4) {
                            //this.completedRegistration = true;
                            this.accountCreated = true;

                            // if (response.Status == 1) {
                            //     this.successMessage = "To get started, click `login` and put in the credentials you just created."
                            // } else {
                            //     this.successMessage = "Please contact our support line to get started: 800-969-6518";
                            // }
                        } else {
                            //this.completedRegistration = false;

                            for (var index in response.Messages) {
                                this.backendError += response.Messages[index] + "\n";
                            }
                            this.accountFailed = true;
                        }

                        // if (!this.completedRegistrationFailed) {
                        //     this.cardError = "";

                        //     for (var index in response.Messages) {
                        //         this.cardError += response.Messages[index] + "\n";
                        //     }
                        // }

                    },
                    error => this.error = <any>error);
        }
    }


    public completedRegistration: boolean = false;
    public completedRegistrationFailed: boolean = false;

    ngOnDestroy() {

    }

    public isSevenDayTrial: boolean = false;//Your credit card will not be billed until the end of your 7 day trial period.

    public monthlyPrice = '59.00';
    public annualPrice = '599.00';
    agentAgreement;

    updateAddEditClientScreen(page) {
        this.signUpForm.personalInformation.invitationCode = localStorage.getItem('invitationCode');
        if (page !== this.currentAddEditClientScreen) {
            //this.signUpForm.personalInformation.invitationCode = localStorage.getItem('invitationCode');
            this.previousAddEditClientScreen = this.currentAddEditClientScreen;
            this.currentAddEditClientScreen = page;
            this.validateFields(page);
        }

        if (page == 0 && this.signUpForm.personalInformation.invitationCode.length > 0) {

            if (this.signUpForm.personalInformation.invitationCode == 'FreeHv$') {
                this.showCreateAccountBtn = true;
            } else {
                //grab pricing for this invitation code
                this.globalService.GetOrganizationInfo('{"InvitationCode": "' + this.signUpForm.personalInformation.invitationCode + '"}')
                    .subscribe(prices => {
                        //console.log('prices', prices);
                        //if (JSON.parse(prices) != null) {
                        if (prices) {
                            /* this.monthlyPrice = JSON.parse(prices).CompletePackageMonthly;
                            this.annualPrice = JSON.parse(prices).CompletePackageAnnual;
                            this.agentAgreement = JSON.parse(prices).AgentAgreement; */
                            this.monthlyPrice = !(prices.CompletePackageMonthly.toString().includes('.')) ? '$' + prices.CompletePackageMonthly : this.currencyPipe.transform(prices.CompletePackageMonthly);
                            this.annualPrice = prices.CompletePackageAnnual;
                            this.agentAgreement = prices.AgentAgreement;

                            //if (JSON.parse(prices).CompletePackageMonthly == '0.01') { //checking pricing
                            if (prices.CompletePackageMonthly == '0.01') {
                                this.showCreateAccountBtn = true;
                            }
                        }
                    });
            }
        } else {
            //this.showCreateAccountBtn = false;
        }
    }

    canContinue(i, isButton = false) {
        if (isButton) {                        
            if (i >= 1) {
                isButton = isButton ? (this.agentForm.valid ? true : false) : false;
            }

            if(i >= 2){
                isButton = (i >= 2 ? (this.generalForm.valid ? true : false) : false);
                isButton = (this.signUpForm.personalInformation.phone.length == 14 && isButton);
                isButton = isButton ? ((this.generalForm.get('password').value == this.generalForm.get('confirmPassword').value) ? true : false) : false;
            }

            if (i > 2) {
                isButton = isButton ? (this.paymentForm.valid ? true : false) : false;
                isButton = isButton ? this.validateCardExp() : false;
                isButton = isButton ? this.validateCVV() : false;
            }
        }
        return isButton;
        // return isButton ? this.validFormInputs[i].isValid : this.validFormInputs[i - 1] && this.validFormInputs[i - 1].isValid;
    }

    validateCardExp() {
        var val = this.signUpForm.paymentMethod.expDate.split('/');
        if (this.signUpForm.paymentMethod.expDate.length === 5 && val[0].length === 2 && val[1].length === 2 && Number(val[0]) && Number(val[1])) {
            return true;
        } else {
            return false;
        }
    }

    validateCVV() {
        if (Number(this.signUpForm.paymentMethod.cvv) && this.signUpForm.paymentMethod.cvv.length > 2 && this.signUpForm.paymentMethod.cvv.length < 5) {
            return true
        } else {
            return false;
        }

    }

    selectBillingPackage(billingPackage) {
        // this.signUpForm.softwareSubscription.package = billingPackage;

        if (billingPackage === 'full') {
            this.signUpForm.softwareSubscription.price = this.billingPeriod === 0 ? this.monthlyPrice : this.annualPrice;
        }

        // if (billingPackage === 'mmt') {
        //     this.signUpForm.softwareSubscription.price = this.billingPeriod === 0 ? '8.66' : '99.99';
        // } else if (billingPackage === 'ss') {
        //     this.signUpForm.softwareSubscription.price = this.billingPeriod === 0 ? '27.40' : '99.99';
        // } else if (billingPackage === 'hc-ltc') {
        //     this.signUpForm.softwareSubscription.price = this.billingPeriod === 0 ? '45.74' : '99.99';
        // } else if (billingPackage === 'full') {
        //     this.signUpForm.softwareSubscription.price = this.billingPeriod === 0 ? '54.91' : '99.99';
        // }

        // this.selectedPackage = billingPackage;
    }

    updateBillingPeriod(period) {
        this.signUpForm.softwareSubscription.frequency = period === 0 ? 'monthly' : 'annual';
        this.billingPeriod = period;
    }

    validateFields(page) {
        var isValid = true;

        if (page === 0) {
            // isValid = isValid && this.signUpForm.personalInformation.invitationCode.length > 0;
            isValid = isValid && this.signUpForm.personalInformation.firstName.length > 0;
            isValid = isValid && this.signUpForm.personalInformation.lastName.length > 0;
            // isValid = isValid && this.signUpForm.personalInformation.jobTitle.length > 0;
            isValid = isValid && this.signUpForm.personalInformation.address1.length > 0;
            // isValid = isValid && this.signUpForm.personalInformation.address2.length > 0;
            isValid = isValid && this.signUpForm.personalInformation.state.length > 0;
            isValid = isValid && this.signUpForm.personalInformation.zip.length > 0;
            isValid = isValid && this.signUpForm.personalInformation.email.length > 0;
            isValid = isValid && this.signUpForm.personalInformation.phone.length > 0;
            //isValid = isValid && this.signUpForm.personalInformation.username.length > 0;

            isValid = isValid && this.usernameRegex.test(this.signUpForm.personalInformation.username) && this.signUpForm.personalInformation.username.length > 0;
            isValid = isValid && this.mediumRegex.test(this.signUpForm.personalInformation.password);
            isValid = isValid && this.mediumRegex.test(this.signUpForm.personalInformation.passwordConfirm);
        } else if (page === 1) {
            isValid = isValid && this.signUpForm.agentAgreement.agrees == true;
        } else if (page === 2) {
            isValid = isValid && this.signUpForm.agentAgreement.agrees == true;
        } else if (page === 3) {
            isValid = isValid && this.signUpForm.paymentMethod.cardNumber.length > 0;
            isValid = isValid && this.signUpForm.paymentMethod.expDate.length > 0;
            isValid = isValid && this.signUpForm.paymentMethod.cvv.length > 0;
            isValid = isValid && this.signUpForm.paymentMethod.firstName.length > 0;
            isValid = isValid && this.signUpForm.paymentMethod.lastName.length > 0;
            // isValid = isValid && this.signUpForm.paymentMethod.company.length > 0;
            isValid = isValid && this.signUpForm.paymentMethod.address1.length > 0;
            // isValid = isValid && this.signUpForm.paymentMethod.address2.length > 0;
            isValid = isValid && this.signUpForm.paymentMethod.state.length > 0;
            isValid = isValid && this.signUpForm.paymentMethod.city.length > 0;
            isValid = isValid && this.signUpForm.paymentMethod.zip.length > 0;
        }

        // console.log(this.signUpForm);
        // console.log(isValid);
        // console.log(this.validFormInputs);

        this.validFormInputs[page].isValid = isValid;
    }

    createAccount() {
        //only hit this for free accounts
        var ClientData = {
            //DataValue: arguments[0].opaqueData.dataValue, //only used for one-time-token
            //DataDescriptor: arguments[0].opaqueData.dataDescriptor, //only used for one-time-token
            DataValue: '',
            DataDescriptor: '',
            ProductCode: this.signUpForm.softwareSubscription.package,
            ProductDuration: this.signUpForm.softwareSubscription.frequency,
            FirstName: this.signUpForm.paymentMethod.firstName,
            LastName: this.signUpForm.paymentMethod.lastName,
            City: this.signUpForm.paymentMethod.city || '',
            State: this.signUpForm.paymentMethod.state,
            Zip: this.signUpForm.paymentMethod.zip,
            Phone: this.signUpForm.personalInformation.phone || '',

            Email: this.signUpForm.personalInformation.email || '',
            Address: this.signUpForm.paymentMethod.address1,
            Company: this.signUpForm.paymentMethod.company,
            CustomerFirstName: this.signUpForm.personalInformation.firstName,
            CustomerLastName: this.signUpForm.personalInformation.lastName,
            CustomerEmail: this.signUpForm.personalInformation.email || '',
            CustomerPhone: this.signUpForm.personalInformation.phone || '',
            CustomerAddress: this.signUpForm.personalInformation.address1,
            CustomerZip: this.signUpForm.personalInformation.zip,
            CustomerState: this.signUpForm.personalInformation.state
        }

        var UserModel = {
            InvitationalCode: this.signUpForm.personalInformation.invitationCode,
            FirstName: this.signUpForm.personalInformation.firstName,
            LastName: this.signUpForm.personalInformation.lastName,
            JobTitle: this.signUpForm.personalInformation.jobTitle,
            Address1: this.signUpForm.personalInformation.address1,
            Address2: this.signUpForm.personalInformation.address2,
            City: this.signUpForm.personalInformation.city,
            State: this.signUpForm.personalInformation.state,
            Zip: this.signUpForm.personalInformation.zip,
            Email: this.signUpForm.personalInformation.email,
            Phone: this.signUpForm.personalInformation.phone,
            Username: this.signUpForm.personalInformation.username,
            AgentAgrees: this.signUpForm.agentAgreement.agrees,
            Duration: this.signUpForm.softwareSubscription.frequency,
            Package: this.signUpForm.softwareSubscription.package,
            Price: '',
        }

        var PW = this.signUpForm.personalInformation.password;
        this.sendingPaymentDetails = true;

        this.globalService.CompletePayment({ ClientData, UserModel, PW })
            .subscribe(
                response => {
                    this.completedRegistration = true;
                    this.sendingPaymentDetails = false;

                    if (response.Status == 1 || response.Status == 4) {
                        this.accountCreated = true;
                    } else {
                        for (var index in response.Messages) {
                            this.backendError += response.Messages[index] + "\n";
                        }
                        this.accountFailed = true;
                    }
                },
                error => this.error = <any>error);
    }

    completePayment() {
        this.sendPaymentDataToAnet();
        //this.responseHandler();
    }

    public isBillingChecked: boolean = false;

    toggleBillingInformation(e) {
        if (e.target.checked) {
            this.isBillingChecked = true;
            this.signUpForm.paymentMethod.firstName = this.signUpForm.personalInformation.firstName;
            this.signUpForm.paymentMethod.lastName = this.signUpForm.personalInformation.lastName;
            this.signUpForm.paymentMethod.address1 = this.signUpForm.personalInformation.address1;
            this.signUpForm.paymentMethod.address2 = this.signUpForm.personalInformation.address2;
            this.signUpForm.paymentMethod.city = this.signUpForm.personalInformation.city;
            this.signUpForm.paymentMethod.state = this.signUpForm.personalInformation.state;
            this.signUpForm.paymentMethod.zip = this.signUpForm.personalInformation.zip;
        } else if (e.target && !e.target.checked) {
            this.isBillingChecked = false;
            this.signUpForm.paymentMethod.firstName = '';
            this.signUpForm.paymentMethod.lastName = '';
            this.signUpForm.paymentMethod.address1 = '';
            this.signUpForm.paymentMethod.address2 = '';
            this.signUpForm.paymentMethod.city = '';
            this.signUpForm.paymentMethod.state = '';
            this.signUpForm.paymentMethod.zip = '';
        }
    }

    getRandomString(text) {
        return text + Math.floor((Math.random() * 100000) + 1);
    }

    getRandomInt() {
        return Math.floor((Math.random() * 100000) + 1);
    }

    getRandomAmount() {
        return ((Math.random() * 100) + 1).toFixed(2);
    }

    getDate() {
        return (new Date()).toISOString().substring(0, 10);
    }

    validateString(val, isRequired) {
        var regex = /^[a-zA-Z ]{2,30}$/;
        return val ? regex.test(val) : !isRequired;
    }

    validateAddress(val, isRequired) {
        var regex = /[A-Za-z0-9'\.\-\s\,]/;
        return val ? regex.test(val) : !isRequired;
    }

    validateNumber(val, isRequired) {
        return val ? Number(val) : !isRequired;
    }

    validateZip(val, isRequired) {
        var regex = /^\d{5}(?:[-\s]\d{4})?$/;
        return val ? regex.test(val) : !isRequired;
    }

    validateEmail(val, isRequired) {
        var regex = /[^@]+@[^\.]+\..+/;
        return val ? regex.test(val) : !isRequired;
    }

    validateCardNumber() {
        const regex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        return regex.test(this.signUpForm.paymentMethod.cardNumber);
    }

    validatePassword() {
        return this.signUpForm.personalInformation.password === this.signUpForm.personalInformation.passwordConfirm && this.mediumRegex.test(this.signUpForm.personalInformation.password)
    }

    // validateCVV() {
    //     return Number(this.signUpForm.paymentMethod.cvv) && this.signUpForm.paymentMethod.cvv.length > 2 && this.signUpForm.paymentMethod.cvv.length < 5;
    // }

    // validateCardExp() {
    //     var val = this.signUpForm.paymentMethod.expDate.split('/');
    //     return this.signUpForm.paymentMethod.expDate.length === 5 && val[0].length === 2 && val[1].length === 2 && Number(val[0]) && Number(val[1]);
    // }

    validatePhoneNumber(val, isRequired) {
        val = val ? val.toString() : '';
        var numbers = val ? val.match(/\d/g) : '';
        return val ? numbers.length === 10 : !isRequired;
    }


    usernameError: boolean;
    usernameError1: boolean;

    userEmailAlreadyExists: boolean = false;
    userUsernameAlreadyExists: boolean = false;

    checkUsernameEmail() {
        this.globalService.ValidateUsernameEmail(this.signUpForm.personalInformation.username, this.signUpForm.personalInformation.email)
            .subscribe(
                response => {
                    response = JSON.parse(response);
                    this.userEmailAlreadyExists = response.email === "True" && this.signUpForm.personalInformation.email.length > 0;
                    this.userUsernameAlreadyExists = response.username === "True" && this.signUpForm.personalInformation.username.length > 0;
                },
                error => this.error = <any>error);
    }

    validateUsername(val, isRequired) {

        /*  if(this.signUpForm.personalInformation.username && this.usernameRegex.test(this.signUpForm.personalInformation.username)){
             //make sure username is not already in use
 
             return true;
         } */

        return this.signUpForm.personalInformation.username && this.usernameRegex.test(this.signUpForm.personalInformation.username);
    }

    onPhoneInputChange(event, backspace) {
        let newVal = event.replace(/\D/g, '');
        if (backspace && newVal.length <= 6) {
          newVal = newVal.substring(0, newVal.length - 1);
        }
        if (newVal.length === 0) {
          newVal = '';
        } else if (newVal.length <= 3) {
          newVal = newVal.replace(/^(\d{0,3})/, '($1)');
        } else if (newVal.length <= 6) {
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
        } else if (newVal.length <= 10) {
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
        } else {
          newVal = newVal.substring(0, 10);
          newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
        }

        this.signUpForm.personalInformation.phone = newVal; 
      }
}
